import { Component, inject } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { TegelModule } from '@scania/tegel-angular-17';
import { Router } from '@angular/router';
import { MenuService } from '../../services/menu.service';
import { Menu } from '../../models/menu';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-side-menu',
  imports: [TegelModule],
  templateUrl: './side-menu.html',
  styleUrl: './side-menu.scss',
})
export class SideMenu {
  private readonly router = inject(Router);
  private readonly auth = inject(AuthService);
  private readonly menu = inject(MenuService);
  private readonly user = inject(UserService);
  readonly theme = inject(ThemeService);

  readonly menus = this.menu.items; //vem do backend
  isMenuOpened = this.menu.isOpen;
  selectedMenu = this.menu.selected;

  username = this.user.username;
  useremail = this.user.useremail;
  userphoto = this.user.userphoto;

  navigate(menu: Menu): void {
    if (!menu.path || !this.hasAccess(menu.permissions)) {
      return;
    }

    this.menu.setSignal(false);
    this.router.navigateByUrl(menu.path);
  }

  hasVisibleChildren(menu: Menu): boolean {
    return !!menu.subMenu?.some((item) => this.canShowItem(item));
  }

  canShowItem(menu: Menu): boolean {
    return !menu.hidden && this.isAvailableRoute(menu.path);
  }

  hasAccess(roles: string[] | undefined): boolean {
    return this.auth.checkMenuAccess(roles);
  }

  private isAvailableRoute(path?: string): boolean {
    if (!path) {
      return true;
    }

    const normalizedPath = path
      .split('?')[0]
      .split('#')[0]
      .replace(/^\/+|\/+$/g, '');

    const pathSegments = normalizedPath ? normalizedPath.split('/') : [];

    return this.router.config.some((route) => {
      if (route.path === '**') {
        return false;
      }

      const routeSegments = route.path ? route.path.split('/') : [];

      return (
        routeSegments.length === pathSegments.length &&
        routeSegments.every(
          (segment, index) => segment.startsWith(':') || segment === pathSegments[index],
        )
      );
    });
  }

  mobileMenuAction(action: boolean) {
    this.menu.setSignal(action);
  }

  toggleTheme(): void {
    this.theme.toggle();
  }

  logout(): void {
    this.auth.logout();
  }

  getAccessTooltip(menu: Menu): string | null {
    return this.hasAccess(menu.permissions)
      ? null
      : 'Você não possui acesso a esta funcionalidade.';
  }
}
